<template>
  <div class="allocation-rule-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-name">批量规则</span>
        <span class="count-text"
          >已添加账户数量：<span class="count-num">{{ adCount_len }}</span></span
        >
        <el-button type="text" class="edit-btn" @click="showDialog = true"
          ><svg-icon iconClass="edit" className="icon"></svg-icon>编辑</el-button
        >
      </div>
      <div class="header-table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" width="150" label="属性"> </el-table-column>
          <el-table-column prop="num" label="数量"> </el-table-column>
          <el-table-column prop="rule" label="拆分规则"> </el-table-column>
        </el-table>
      </div>
      <div class="header-table-footer">
        预计在<span class="count-num">{{ adCount_len }}</span
        >个账户创建<span class="count-num">{{ projectNum }}</span
        >个广告系列，<span class="count-num">{{ planNum }}</span
        >个广告组
      </div>
    </div>

    <el-dialog
      title="分配规则"
      :visible.sync="showDialog"
      width="500px"
      :close-on-click-modal="false"
      top="8vh"
    >
      <div class="dialog-body">
        <ul class="rule-list">
          <li class="rule-item">
            <span class="rule-label">地区：</span>
            <el-radio-group v-model="formData.geoGroup" @change="changeRules('region_groups')">
              <el-radio label="CAMPAIGN" :disabled="!!alreadyCampaignId">广告系列</el-radio>
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意组：</span>
            <el-radio-group v-model="formData.creativeGroup" @change="changeRules('creativeGroup')">
              <el-radio label="CAMPAIGN" :disabled="!!alreadyCampaignId">广告系列</el-radio>
              <el-radio label="AD_SET" :disabled="!!alreadyCampaignId">广告组</el-radio>
            </el-radio-group>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      showDialog: false,
      formData: {
        geoGroup: "CAMPAIGN",
        creativeGroup: "CAMPAIGN",
      },
      planNum: 0,
      projectNum: 0,
      timer: null,
    };
  },
  methods: {
    changeRules(key) {
      this.$store.commit("set_split_rule_google", {
        key: key,
        value: this.formData[key],
      });
      this.computedPlan();
    },
    computedPlan() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let planNum = 1;
        let projectNum = 1;
        let numObj = {
          creativeGroup: this.cyz_len,
          geoGroup: this.dqz_len,
        };
        for (let [key, value] of Object.entries(this.formData)) {
          planNum *= numObj[key];
          if (value === "CAMPAIGN") {
            //广告
            projectNum *= numObj[key];
          }
        }
        this.planNum = this.adCount_len * planNum;
        this.projectNum = this.adCount_len * projectNum;
      }, 300);
    },
  },
  computed: {
    ...mapState({
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
      adCount_len: (state) => (state.PromotionGoogle.draftCampaign.advertiserId ? 1 : 0),
      splitRule: (state) => state.PromotionGoogle.splitRule,
      cyz_len: (state) => {
        let list = state.PromotionGoogle.creativeGroups;
        return list ? list.length : 0;
      },
      dqz_len: (state) => {
        let list = state.PromotionGoogle.draftCampaign.targetings;
        return list ? list.length : 0;
      },
    }),
    tableData() {
      return [
        {
          name: "地区组",
          num: this.dqz_len,
          rule:
            this.formData.geoGroup === "AD_SET"
              ? "广告组"
              : this.formData.geoGroup === "CAMPAIGN"
              ? "广告系列"
              : "--",
        },
        {
          name: "创意组",
          num: this.cyz_len,
          rule:
            this.formData.creativeGroup === "AD_SET"
              ? "广告组"
              : this.formData.creativeGroup === "CAMPAIGN"
              ? "广告系列"
              : "--",
        },
      ];
    },
  },
  watch: {
    splitRule: {
      handler(value) {
        if (value) {
          let copyData = JSON.parse(JSON.stringify(value));
          this.formData = copyData;
        }
      },
      deep: true,
    },
    alreadyCampaignId(val) {
      if (val) {
        this.formData = {
          geoGroup: "CAMPAIGN",
          creativeGroup: "AD_SET",
        };
      } else {
        this.formData = {
          geoGroup: "CAMPAIGN",
          creativeGroup: "AD_SET",
        };
      }
      this.$store.commit("set_all_split_rule_google", this.formData);
    },
    adCount_len() {
      this.computedPlan();
    },
    cyz_len() {
      this.computedPlan();
    },
    dqz_len() {
      this.computedPlan();
    },
  },
};
</script>

<style lang="less" scoped>
.allocation-rule-wrap {
  .table-wrap {
    width: 100%;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    box-sizing: border-box;
    .table-header {
      display: flex;
      align-items: flex-end;
      .header-name {
        color: rgba(0, 0, 0, 1);
        font-weight: 500;
        font-size: 16px;
        font-weight: bold;
      }
      .count-text {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        line-height: 15px;
        margin-left: 12px;
        .count-num {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
        }
      }
      .edit-btn {
        margin-left: auto;
        color: rgba(24, 144, 255, 1);
        padding: 0px;
        .icon {
          margin-right: 4px;
        }
      }
    }
    .header-table-wrap {
      margin-top: 24px;
      /deep/ th {
        height: 30px;
      }
      /deep/ .el-table__cell {
        padding: 5px 0;
      }
    }
    .header-table-footer {
      padding-top: 10px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      .count-num {
        margin: 0 4px;
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
      }
    }
  }
  .dialog-body {
    .rule-list {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .rule-item {
        margin-top: 20px;
        .rule-label {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          text-align: right;
          padding-right: 2px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
